import React from 'react'

const SecondPanel = props => (
    <svg viewBox="0 0 455.431 455.431" {...props}>
        <path
            d="M405.39 412.764c-69.689 56.889-287.289 56.889-355.556 0s-62.578-300.089 0-364.089 292.978-64 355.556 0 69.689 307.201 0 364.089z"
            fill="#5ca4da"
        />
        <path
            d="M229.034 313.209c-62.578 49.778-132.267 75.378-197.689 76.8-48.355-82.489-38.4-283.022 18.489-341.333 51.2-52.622 211.911-62.578 304.356-29.867 22.755 93.867-24.178 213.333-125.156 294.4z"
            fill="#6dafe0"
        />
        <path
            d="M248.945 200.853c7.111-9.956 9.956-19.911 9.956-28.444 0-8.533-2.844-17.067-8.533-22.756s-14.222-9.956-22.756-9.956c-17.067 0-34.133 12.8-49.778 36.978l-49.778-28.444c12.8-19.911 27.022-35.556 42.667-45.511s35.556-15.644 58.311-15.644 44.089 7.111 62.578 22.756c18.489 15.644 27.022 35.556 27.022 61.156 0 14.222-4.267 28.444-11.378 41.244s-19.911 29.867-39.822 49.778l-49.778 51.2h109.511v55.467H132.323v-45.511l81.067-82.489c17.066-17.068 28.444-29.868 35.555-39.824z"
            fill="#fff"
        />
    </svg>
)

export default SecondPanel
